import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d08926c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2d08926c&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=2d08926c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d08926c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/卡百利业务中台2.0（前端）生产环境/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d08926c')) {
      api.createRecord('2d08926c', component.options)
    } else {
      api.reload('2d08926c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2d08926c&scoped=true", function () {
      api.rerender('2d08926c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/VabThemeBar/index.vue"
export default component.exports